/* eslint-disable */
import * as React from 'react';

export const Home = () => {
  return (
    <div className="container">
      <ul>
        <li>
          <a href="/render-nucleus/list/view/summary?debug=true&experience=lists-and-registries">Summary</a>
        </li>
        <li>
          <a href="/render-nucleus/list/view/details/123?debug=true&experience=lists-and-registries">List Details</a>
        </li>
        <li>
          <a href="/render-nucleus/list/view/details/shared/123?debug=true&experience=lists-and-registries">Shared List Details</a>
        </li>
      </ul>
    </div>
  );
};

Home.propTypes = {
};

Home.displayName = 'HomePage';

Home.defaultProps = {
  name: '',
};
